import React, { createContext, useEffect, useReducer } from 'react'
import axios from 'axios.js'
import { MatxLoading } from 'app/components'
import OneSignal from 'react-onesignal';
import { useLocation, useNavigate } from 'react-router-dom';

const onesignal_id = process.env.REACT_APP_ONESIGNAL_ID;

const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
}

const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload
            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
            }
        }
        case 'LOGIN': {
            const { user } = action.payload
            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'VERIFY': {
            return {
                ...state,
                isAuthenticated: false,
            }
        }
        case 'RESET': {
            return {
                ...state,
                isAuthenticated: false,
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'CHECK': {
            const { isAuthenticated, user } = action.payload
            return {
                ...state,
                isAuthenticated,
                user,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    verify: () => Promise.resolve(),
    resetPasssword: () => Promise.resolve(),
    check: () => Promise.resolve(),
    logout: () => { },
})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const navigate = useNavigate();
    const location = useLocation();

    const login = async (email, password) => {
        // var player_id = await OneSignal.getUserId() ?? null;
        console.log(email);

        const response = await axios.post('/admin/login', {
            email,
            password,
            // onesignal_id: player_id,
        })

        // const response = await axios.post('/admin/loginAD', {
        //     staff_id,
        //     password,
        //     // onesignal_id: player_id,
        // })

        const { token, user } = response.data.data
        const accessToken = token
        let newUser = {
            ...user,
            role: "",
        }

        setSession(accessToken)
        dispatch({
            type: 'LOGIN',
            payload: {
                user: newUser,
            },
        })
    }

    const loginAD = async (staff_id, password) => {
        // var player_id = await OneSignal.getUserId() ?? null;
        console.log(staff_id);

        const response = await axios.post('/admin/loginAD', {
            staff_id,
            password,
            // onesignal_id: player_id,
        })

        const { token, user } = response.data.data
        const accessToken = token
        let newUser = {
            ...user,
            role: "",
        }

        setSession(accessToken)
        dispatch({
            type: 'LOGIN',
            payload: {
                user: newUser,
            },
        })
    }

    const check = async () => {
        var player_id = '0';

        const response = await axios.get(`/admin/check/${player_id}`)
        const { user } = response.data

        dispatch({
            type: 'CHECK',
            payload: {
                user, isAuthenticated: true
            },
        })
    }

    const logout = async () => {
        await axios.post('/admin/logout')
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }

    const verify = async (url) => {
        logout()
        const response = await axios.get(url)
        return response.data.message;
    }

    const resetPasssword = async (param) => {
        logout()
        const response = await axios.post('admin/forgotpassword/reset', param)
        return response.data.message;
    }

    const forgotPassword = async (param) => {
        const response = await axios.post('/admin/forgotpassword/send', param)
        return response.data.message;
    }

    useEffect(() => {
        ; (async () => {
            try {
                // OneSignal.init({ appId: onesignal_id });

                const accessToken = window.localStorage.getItem('accessToken')

                if (accessToken) {
                    setSession(accessToken)

                    var player_id = '0';

                    const response = await axios.get(`/admin/check/${player_id}`)
                    const { user } = response.data

                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: true,
                            user,
                        },
                    })

                    if (location.pathname === '/account/signin') navigate('/')

                } else {
                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                forgotPassword,
                login,
                loginAD,
                verify,
                resetPasssword,
                check,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
